// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"5eecd930","453":"47629cb4","455":"302b7653","677":"dc66f6cf","977":"9dd3bb6a"}[chunkId] + ".chunk.js";
};